export default __webpack_public_path__ + "static/media/img3.1e68e30f.jpg";